import type { Attachment } from '@core/attachments-types';

export enum EntityStoreKey {
  attachments = 'attachments',
  ViewboxAttachments = 'viewbox-attachments',
  hiddenAttachments = 'hiddenAttachments',
}

export interface AttachmentsStore {
  attachments: Attachment[];
}

export enum AttachmentsDataScope {
  Candidate = 'candidate',
  Offer = 'offer',
  TalentPool = 'talent_pool',
  Requisition = 'requisition',
}
